/*
 * Controls for changing touchpoint/language of the selected response, as well as
 * the edit and history buttons
 */

define([
  "marionette",
  "jquery",
  "messaging/messenger",
  "modules/topicsSplit/topic/topicResponse/topicResponsePreview/template/topicResponsePreviewTemplate.html",
  "modules/header/kbMenu/kbMenuModel",
  "modules/topicsSplit/topic/topicResponse/topicResponseModel",
  "jquery-ui/ui/widgets/accordion",
], function (Marionette, $, Messenger, TopicResponsePreviewTemplate, KbMenuModel) {
  "use strict";

  const TopicResponsePreviewView = {};

  // noinspection JSUnusedGlobalSymbols
  TopicResponsePreviewView.topicResponsePreviewView = Marionette.Layout.extend({
    template: TopicResponsePreviewTemplate,

    events: {
      "change #touchpoints": function () {
        const optionSelected = this.$el.find("#touchpoints option:selected").val();
        this.trigger("change:touchpoint", optionSelected);
      },
      "change #languages": function () {
        const optionSelected = this.$el.find("#languages option:selected").val();
        this.trigger("change:language", optionSelected);
      },
      "change #targetLanguages": function () {
        const optionSelected = this.$el.find("#targetLanguages option:selected").val();
        this.trigger("change:targetLanguage", optionSelected);
      },
      "change #responseType": function () {
        const optionSelected = this.$el.find("#responseType option:selected").val();
        this.trigger("change:response:type", optionSelected);
      },
    },
    modelEvents: {
      change: "render",
    },
    triggers: {
      "click #edit": "edit:response",
      "click #viewResponseSource": "open:response:source",
      "click #translate": "translate:response",
      "click #history": "response:history",
      "click #reviewResponse": "response:review",
      "click #actionGroupEdit": "edit:action:group",
      "click #deleteActionGroup": "delete:action:group",
      "click #deleteCollabData": "delete:collab:data",
      "click #actionGroupLink": "click:action:group",
      "click #copyResponse": "response:copy",
      "click #responseCampaign": "open:response:campaign:modal",
      "click #responseTranslation": "open:response:translation:modal",
      "click #shareResponseLink": "open:shareResponseLink",
    },
    regions: {
      responseTemplateStatus: "#responseTemplateStatus",
    },
    onDomRefresh: function () {
      // Enable extra jQuery UI widgets in response
      $(".accordion").accordion({
        collapsible: true,
        heightStyle: "content",
      });
    },
    templateHelpers: {
      isEmpty: function (responseTemplate) {
        return !responseTemplate || responseTemplate.isEmpty();
      },
      isPending: function (responseTemplate) {
        return (
          responseTemplate &&
          responseTemplate.get("statusId") == KbMenuModel.statuses.VERSIONED_PENDING_RESPONSE
        );
      },
      hasTouchpoint: function (touchpointLocaleMap, touchpointId) {
        return touchpointLocaleMap && touchpointLocaleMap.has(touchpointId);
      },
      hasTouchpointLanguage: function (touchpointLocaleMap, touchpointId, languageId) {
        if (touchpointLocaleMap) {
          const languages = touchpointLocaleMap.get(touchpointId);
          if (languages) {
            return languages.indexOf(languageId) >= 0;
          }
        }
        return false;
      },
      formatDateTime: function (timestamp) {
        return Messenger.reqres.request("get:formatted:dateTime", timestamp);
      },
    },
  });

  return TopicResponsePreviewView;
});
